<template>
  <v-autocomplete
    :items="items"
    v-model="selectedBoardBasis"
    label="Board Basis"
    item-text="name"
    item-value="name"
    @change="changeListener($event)"
    :outlined="outlined"
  ></v-autocomplete>
</template>

<script>
import { ALL_BOARD_BASES_SEARCH_QUERY } from "../../../constants/graphql";
import { removeGQLTypename } from "../../../helpers";

export default {
  name: "BoardBasisListSelect",

  props: {
    value: {
      type: String,
      default: () => "",
    },
    boardBasis: { type: String },
    outlined: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      boardBasesList: [],
      selectedBoardBasis: this.value != "" ? this.value : null,
    };
  },

  computed: {
    items() {
      return this.boardBases && this.boardBases.edges
        ? this.boardBases.edges.map(removeGQLTypename).filter((item) => {
            return this.value != ""
              ? item.name == this.value || !item.notInUse
              : !item.notInUse;
          })
        : [];
    },
  },

  methods: {
    changeListener(data) {
      if (typeof data == "string") {
        this.$emit("onSelect", data);
        this.$emit("input", data);
        this.$emit("change", data);
      }
    },
  },

  watch: {
    boardBasis() {
      this.selectedBoardBasis = this.boardBasis;
    },
    value(newVal) {
      this.selectedBoardBasis = newVal;
    },
  },

  apollo: {
    boardBases: {
      query: ALL_BOARD_BASES_SEARCH_QUERY,
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/shared/BoardBasisListSelect.vue